import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../services/PostData';
import { GetData } from '../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table
} from 'reactstrap';
import $ from 'jquery';
import QuestionPage from '../views/QuestionPage/';

class Lesson extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			dept: '',
			_message: '',
			alertClass: '',
			posts: [],
			classes :[],
			accyear : [],
			books : [],
			subject : [],
			acyear : '',
			isedit: 0
		}
		this.onacChange = this.onacChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onClsChange = this.onClsChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		document.getElementById("editform").reset();
		this.setState({ isedit: 0, dept: '' });
		$("#department").val('');
		document.getElementById("userform").reset();
	}

	onacChange(e){
		$("#clas").val('');
		$("#sub").val('');
		this.setState({[e.target.name]:e.target.value,data : [],isbtnview : false,isview : false});
	}

	onClsChange(e){
		$("#sub").val('');
		this.setState({ [e.target.name]: e.target.value });
		this.getsubject();
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	onSubmit(e) {
		e.preventDefault();

		$("#showLoader").show();
		PostData('question/addlesson', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Lesson Added Successfully!..',
					alertClass: 'alert alert-success',
				});
				document.getElementById("userform").reset();
				this.getacyear();
				this.getdata();
			}
			else {

				this.setState({
					_message: 'Already Added',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	handleClick(dd) {

		this.state.id = dd;

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			GetData('question/deletelesson/'+ this.state.id).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Lesson Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: responseJson.msg,
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	onUpdateSubmit(e) {
		e.preventDefault();

		$("#showLoader").show();
		PostData('question/updatelesson', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;

			if (responseJson.status == '1') {
				document.getElementById("editform").reset();
				this.setState({
					_message: 'Lesson Updated Successfully!..',
					alertClass: 'alert alert-success',
					isedit: 0
				});
				this.getdata();
			}
			else {
				this.setState({
					_message: 'Book Already Added..',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	handleEditClick(id) {

		var d = this.state.posts;
		var index = d.findIndex(function (obj) {
			return (obj.id == id);
		});

		$("#year").val(d[index]['acyear']);
		$("#clas").val(d[index]['class']);

		this.setState({ acyear : d[index]['acyear'],cls : d[index]['class'],lesson : d[index]['lesson'],book: d[index]['book'], id: id});
		this.getsubject();
		this.setState({sub : d[index]['subject'], isedit: 1 });
	}

	componentDidMount() {

		this.getacyear();
		this.getdata();
		this.getclass();
		this.getbooks();
	}

	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}

	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					classes : responseJson
				});
			}
		});
	}

	getbooks() {
		$("#showLoader").show();
		GetData('question/getbooks').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					books: responseJson
				});
			}
		});
	}

	getdata() {
		$("#showLoader").show();
		GetData('question/getlessons').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	getsubject(){
		
		var ac = $("#year").val();
		var cls = $("#clas").val();
		$("#showLoader").show();
		GetData('assignsubject/getsubbycls/'+ac+'/'+cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					subject : responseJson
				});
			}
		});
	}

	render() {

		let userData = JSON.parse(sessionStorage.getItem('userData'));
		this.state.userId = userData['userid'];
		var acyear = this.state.accyear;

		return (
			<div>
				<QuestionPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						{this.state.isedit == 0 ?
							<Col md="5">
								<Card>
									<form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit} >
										<CardHeader>
											<strong>Add Lesson</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											Academic Year : &nbsp;&nbsp;
											<select name="acyear" onChange={this.onacChange} required id="year">
												<option value="">Select</option>
												{
													acyear.map(function (item) {
														return <option value={item.id }>{item.value}</option>;
													})
												}
											</select>
										</CardHeader>
										<CardBody>
											<Row>
												<Col md="12">
													<FormGroup>
														<Label>Class <span className="text-danger">*</span></Label>
														<select name="cls" onChange={this.onClsChange} id="clas" className="form-control" required > 
															<option value="">Select Class</option>
															{
																this.state.classes.map(function (item) {
																	return <option value={item.id}>{item.class}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
												<Col md="12">
													<FormGroup>
														<Label>Subject <span className="text-danger">*</span></Label>
														<select name="sub" onChange={this.onChange} id="sub" className="form-control" required > 
															<option value="">Select Subject</option>
															{
																this.state.subject.map(function (item) {
																	return <option value={item.subject}>{item.sub}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
												<Col md="12">
													<FormGroup>
														<Label>Book <span className="text-danger">*</span></Label>
														<select name="book" onChange={this.onChange} id="book" className="form-control" required > 
															<option value="">Select Book</option>
															{
																this.state.books.map(function (item) {
																	return <option value={item.id}>{item.book}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
												<Col md="12">
													<FormGroup>
														<Label htmlFor="name">Lesson <span className="text-danger">*</span></Label>
														<Input type="number" id="lesson" name="lesson" required onChange={this.onChange} />
													</FormGroup>
												</Col>
											</Row>
										</CardBody>
										<CardFooter>
											<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
											<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
										</CardFooter>
									</form>
								</Card>
							</Col> :
							<Col md="5">
								<Card>
									<form action="" method="post" role="form" id="editform" encType="multipart/form-data" onSubmit={this.onUpdateSubmit} >
										<CardHeader>
											<strong>Edit Lesson</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											Academic Year : &nbsp;&nbsp;
											<select name="acyear" required id="year">
												<option value="">Select</option>
												{
													acyear.map(function (item) {
														return <option value={item.id }>{item.value}</option>;
													})
												}
											</select>
											<Button type="reset" size="sm" style={{ float: 'right' }} color="primary" onClick={this.onClick}>Add</Button>
										</CardHeader>
										<CardBody>
											<Row>
												<Col md="12">
													<FormGroup>
														<Label>Class <span className="text-danger">*</span></Label>
														<select name="cls" onChange={this.onClsChange} id="clas" className="form-control" value={this.state.cls} required > 
															<option value="">Select Class</option>
															{
																this.state.classes.map(function (item) {
																	return <option value={item.id}>{item.class}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
												<Col md="12">
													<FormGroup>
														<Label>Subject <span className="text-danger">*</span></Label>
														<select name="sub" onChange={this.onChange} id="sub" className="form-control" value={this.state.sub} required > 
															<option value="">Select Subject</option>
															{
																this.state.subject.map(function (item) {
																	return <option value={item.subject}>{item.sub}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
												<Col md="12">
													<FormGroup>
														<Label>Book <span className="text-danger">*</span></Label>
														<select name="book" onChange={this.onChange} id="book" className="form-control" value={this.state.book} required > 
															<option value="">Select Book</option>
															{
																this.state.books.map(function (item) {
																	return <option value={item.id}>{item.book}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
												<Col md="12">
													<FormGroup>
														<Label htmlFor="name">Lesson <span className="text-danger">*</span></Label>
														<Input type="number" id="lesson" name="lesson" required onChange={this.onChange} value={this.state.lesson} />
													</FormGroup>
												</Col>
											</Row>
										</CardBody>
										<CardFooter>
											<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
										</CardFooter>
									</form>
								</Card>
							</Col>}
						<Col md="7">
							<Card>
								<CardBody>
									<Table responsive bordered>
										<thead>
											<tr>
												<th>S.No</th>
												<th>Class</th>
												<th>Subject</th>
												<th>Book</th>
												<th>Lesson</th>
												<th width="100">Manage</th>
											</tr>
										</thead>
										<tbody>
											{this.state.posts.map((item, i) =>

												<tr key={item}>
													<td>{i + 1}</td>
													<td>{item.clsname}</td>
													<td>{item.subname}</td>
													<td>{item.bookname}</td>
													<td>{item.lesson}</td>
													<td>
														<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.handleEditClick(item.id)} ><i className="fa fa-edit"></i></button>&nbsp;
														<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
													</td>
												</tr>

											)}
										</tbody>
									</Table>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default Lesson;


// WEBPACK FOOTER //
// ./src/Questions/Lesson.js